import styled from 'styled-components';

const Title = styled.h1`
  font-size: 7vh;
  max-width: 90vw;
  font-family: "Poppins", "Inter", sans-serif;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: none;
  line-height: 1.1;
  text-align: center;
  color: #1a1a1a; /* Preto suave para modo claro */

  /* Sombra leve para destacar em fundos claros */
  text-shadow: 
    0 2px 4px rgba(0, 0, 0, 0.2),
    0 4px 12px rgba(0, 0, 0, 0.08);

  transition: color 0.4s ease, text-shadow 0.4s ease;

  /* 🌙 Modo escuro refinado */
  @media (prefers-color-scheme: dark) {
    color: #000000ff; /* branco suave, não estoura */
    text-shadow:
      0 1px 2px rgba(0, 0, 0, 0.5),
      0 2px 6px rgba(0, 0, 0, 0.4);
  }

  @media (max-aspect-ratio: 1.25/1) {
    font-size: 6.2vh;
  }

  @media (max-aspect-ratio: 1/1) {
    font-size: 5.5vh;
  }

  @media (max-aspect-ratio: .4/1) {
    font-size: 5vh;
  }
`;

export default Title;
